/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { ModifiedInteractiveDetails } from "../models/modified-interactive-details";
@Injectable({
  providedIn: "root",
})
class AdminModifiedInteractiveService extends __BaseService {
  static readonly adminModifiedInteractiveGetModifiedInteractivesPath =
    "/api/admin/interactive/AdminModifiedInteractive/GetModifiedInteractives";
  static readonly adminModifiedInteractiveDeleteModifiedInteractivePath =
    "/api/admin/interactive/AdminModifiedInteractive/DeleteModifiedInteractive";
  static readonly adminModifiedInteractiveDeleteModifiedInteractivePermanentPath =
    "/api/admin/interactive/AdminModifiedInteractive/DeleteModifiedInteractivePermanent";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminModifiedInteractiveGetModifiedInteractivesResponse(): __Observable<
    __StrictHttpResponse<Array<ModifiedInteractiveDetails>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminModifiedInteractive/GetModifiedInteractives`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ModifiedInteractiveDetails>>;
      })
    );
  }
  adminModifiedInteractiveGetModifiedInteractives(): __Observable<
    Array<ModifiedInteractiveDetails>
  > {
    return this.adminModifiedInteractiveGetModifiedInteractivesResponse().pipe(
      __map((_r) => _r.body as Array<ModifiedInteractiveDetails>)
    );
  }

  /**
   * @param modifiedInteractiveId undefined
   */
  adminModifiedInteractiveDeleteModifiedInteractiveResponse(
    modifiedInteractiveId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (modifiedInteractiveId != null)
      __params = __params.set(
        "modifiedInteractiveId",
        modifiedInteractiveId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminModifiedInteractive/DeleteModifiedInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param modifiedInteractiveId undefined
   */
  adminModifiedInteractiveDeleteModifiedInteractive(
    modifiedInteractiveId?: number
  ): __Observable<boolean> {
    return this.adminModifiedInteractiveDeleteModifiedInteractiveResponse(
      modifiedInteractiveId
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param modifiedInteractiveId undefined
   */
  adminModifiedInteractiveDeleteModifiedInteractivePermanentResponse(
    modifiedInteractiveId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (modifiedInteractiveId != null)
      __params = __params.set(
        "modifiedInteractiveId",
        modifiedInteractiveId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/interactive/AdminModifiedInteractive/DeleteModifiedInteractivePermanent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param modifiedInteractiveId undefined
   */
  adminModifiedInteractiveDeleteModifiedInteractivePermanent(
    modifiedInteractiveId?: number
  ): __Observable<boolean> {
    return this.adminModifiedInteractiveDeleteModifiedInteractivePermanentResponse(
      modifiedInteractiveId
    ).pipe(__map((_r) => _r.body as boolean));
  }
}

module AdminModifiedInteractiveService {}

export { AdminModifiedInteractiveService };
